module.exports = {"370323001":"历山街道","370323002":"南麻街道","370323102":"鲁村镇","370323103":"东里镇","370323104":"悦庄镇","370323105":"西里镇","370323106":"大张庄镇","370323107":"中庄镇","370323108":"张家坡镇","370323109":"燕崖镇","370323110":"石桥镇","370323111":"南鲁山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370323.json
// module id = 1383
// module chunks = 0